import { Box, Button, Heading, Image, Text } from '@chakra-ui/react'
import React from 'react'

import { Container } from '@/components/Container'
import { Head } from '@/components/Head'
import { Header } from '@/components/Header'
import { Layout } from '@/components/Layout'

const Terms = () => {
  return (
    <Layout>
      <Head path="/about" title="About" />
      <Container>
        <Header />
        <Box mt="8" fontWeight="bold">
          <Heading as="h1">About</Heading>

          <Box mt="4">
            <Text fontSize="xl">About CryptoUkiyoe</Text>
            <Box mt="2">
              <Text>
                CryptoUkiyoe is 5,000 unique collectible Ukiyo-e style digital art with proof of
                ownership stored on the Ethereum Blockchain.
              </Text>
              <Text>
                Each CryptoUkiyoe is a programmatically generated 32x32 PNG, enlarged to 448x448,
                and stored as an ERC-1155 token provided by OpenSea.
              </Text>
              <Text>Each one is unique and created from 3 to 7 facial attributess.</Text>
            </Box>

            <Box mt="8">
              <Image
                fit="contain"
                className="pixelated"
                src={`/images/about.png`}
                alt="CryptoUkiyoe"
              />
            </Box>

            <Text mt="8" fontSize="xl">
              About Creator
            </Text>
            <Box mt="2">
              <Text>Sharacue is Ukiyo-e pixel artist who likes crypto and NFTs.</Text>
              <Text>I enjoy drawing pixel art and writing code.</Text>
              <Box mt="4" display="flex">
                <Box>
                  <a href="https://twitter.com/sharacue" target="_blank" rel="noopener noreferrer">
                    <Button colorScheme="teal" variant="outline" minW="30">
                      Twitter
                    </Button>
                  </a>
                </Box>
                <Box ml="8">
                  <a
                    href="https://www.instagram.com/sharacuenft/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button colorScheme="teal" variant="outline" minW="30">
                      Instagram
                    </Button>
                  </a>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </Layout>
  )
}

export default Terms
